import Popconfirm from "antd/es/popconfirm";
import Button from "antd/es/button";
import Alert from "antd/es/alert";
import React from "react";
import ReactPlayer from "react-player/youtube";
import http from "../utils/http";

export default function Queue({
  queue,
  setWaiting,
  handleLogout,
  response,
  platform,
}) {
  React.useEffect(() => {
    if (response?.room?.uniqueName) {
      if (platform) {
        localStorage.setItem("sid-vonage", response.room.uniqueName);
      } else {
        localStorage.setItem("sid", response.room.uniqueName);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response?.room?.uniqueName]);

  return (
    <div className="wrapper" style={{ backgroundColor: window.THEMES.bgColor }}>
      <div className="inqueue">
        {process.env.REACT_APP_LINK_VIDEO_ID ? (
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${process.env.REACT_APP_LINK_VIDEO_ID}`}
            loop={true}
            controls={false}
            width={"100%"}
            height={"250px"}
            playing={true}
          />
        ) : (
          <img
            src={"LOGO DJKI 2.png"}
            style={{
              width: "100%",
              height: 150,
              objectFit: "contain",
              marginTop: 10,
              marginBottom: 10,
            }}
            alt="Logo DJKI"
          />
        )}
        <div className="inqueue-count">
          <div style={{ fontSize: "12px" }}>Posisi Antrian Saat Ini</div>
          <div className="count" style={{ marginTop: 10, marginBottom: 10 }}>
            {queue?.inQueue || 0}
          </div>
          <div style={{ fontSize: "12px" }}>
            Posisi Anda dalam antrian: {queue?.queuePosition || 0}
          </div>
        </div>
        <Popconfirm
          placement="top"
          title={"Anda yakin ingin membatalkan sesi ini?"}
          onConfirm={() => {
            http
              .post(
                `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/cancel/${response?.room?.uniqueName}`
              )
              .then((res) => {
                if (res) {
                  localStorage.removeItem("sid");
                  setWaiting(false);
                  handleLogout();
                }
              });
          }}
          okText="Iya"
          cancelText="Tidak"
        >
          <Button
            type="primary"
            danger
            size="small"
            style={{ fontSize: 12, margin: "auto", display: "block" }}
          >
            Batalkan Sesi
          </Button>
        </Popconfirm>
        <div className="inqueue-wording">
          <div>
            <div
              style={{
                fontSize: "14px",
                textAlign: "center",
                marginBottom: 20,
              }}
            >
              Mohon tunggu, agent kami akan segera melayani Anda. Jangan menutup
              tampilan browser Anda
            </div>
          </div>
          <div>
            <Alert
              message={
                <span
                  style={{
                    fontSize: 12,
                    fontStyle: "italic",
                    textAlign: "justify",
                  }}
                >
                  Pelanggan Yth, seluruh interaksi ini akan kami rekam.
                  <span style={{ color: "red", fontWeight: "bold" }}>
                    &nbsp;Dimohon untuk tidak mengambil atau/dan menyebarluaskan
                    audio/gambar/video dari interaksi percakapan.
                  </span>{" "}
                  Kegiatan tersebut termasuk dalam penyalahgunaan dan akan
                  ditindak sesuai dengan peraturan perundang-undangan yang
                  berlaku.
                </span>
              }
              type="warning"
              banner
              showIcon={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
